import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';

export interface CreditPackage {
    credits: number;
    priceInCents: number;
    priceFormatted: string;
}

export interface CreditPackagesResponse {
    packages: CreditPackage[];
    publishableKey: string;
}

export function useCreditPackages() {
    return useQuery<CreditPackagesResponse>({
        queryKey: ['credits', 'packages'],
        queryFn: () => api.get('/api/credits/packages'),
    });
}
